import React, { useEffect, useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import PosicionesEtapaTorneo from '../../tablas/PosicionesEtapaTorneo.js';
import MensajeCargando from '../../UI/MensajeCargando.js';
import MensajeError from '../../UI/MensajeError.js';
import BotoneraFiltros from '../../UI/BotoneraFiltros.js';
import UserContext from '../../../context/UserContext.js';
import useGetListaURL from '../../../hooks/useGetListaURL.js';
import * as Funciones from '../../funciones/FuncionesTorneos.js';

const TipoPosiciones = {
  GRABADA: 'grabada',
  CALCULADA: 'calculada',
};

const PosicionesTorneo = (props) => {
  const datosElegidos = props.datosElegidos;
  const [posiciones, setPosiciones] = useState([]);
  const [tipoPosiciones, setTipoPosiciones] = useState(TipoPosiciones.GRABADA);
  const [intentoCambioAutomatico, setIntentoCambioAutomatico] = useState(false);
  const { isCargando, erroresGetLista, fetchData, resetErroresGetLista } = useGetListaURL();
  const { usuario } = useContext(UserContext);
  const puedeEditar = usuario && usuario.puedeEditar;

  const filtrosPosiciones = [
    { codigo: TipoPosiciones.GRABADA, descripcion: 'Grabada' },
    { codigo: TipoPosiciones.CALCULADA, descripcion: 'Calculada' },
  ];

  useEffect(() => {
    resetErroresGetLista();
  }, [resetErroresGetLista]);

  const url = Funciones.URLPosicionesTorneo(
    datosElegidos,
    tipoPosiciones === TipoPosiciones.CALCULADA
  );

  useEffect(() => {
    if (url) {
      fetchData(url, setPosiciones);
    } else {
      setPosiciones([]);
    }
  }, [url, fetchData]);

  // Efecto para cambiar automáticamente a "Calculada" si "Grabada" no trae datos
  useEffect(() => {
    if (
      puedeEditar &&
      !isCargando &&
      !erroresGetLista &&
      tipoPosiciones === TipoPosiciones.GRABADA &&
      (!posiciones || posiciones.length === 0) &&
      !intentoCambioAutomatico
    ) {
      // Solo intentar cambiar una vez para evitar loops infinitos
      setIntentoCambioAutomatico(true);
      setTipoPosiciones(TipoPosiciones.CALCULADA);
    }
  }, [
    puedeEditar,
    isCargando,
    erroresGetLista,
    tipoPosiciones,
    posiciones,
    intentoCambioAutomatico,
  ]);

  // Resetear el flag de cambio automático cuando cambia la etapa
  useEffect(() => {
    setIntentoCambioAutomatico(false);
    setTipoPosiciones(TipoPosiciones.GRABADA);
  }, [datosElegidos.etapa]);

  const onTipoPosicionesElegido = (tipo) => {
    setTipoPosiciones(tipo);
  };

  const navigate = useNavigate();
  const onEquipoElegido = (idEquipo) => {
    navigate('/torneo/' + datosElegidos.torneo.id + '/equipo/' + idEquipo, {
      state: { datosElegidos },
    });
  };

  return (
    <React.Fragment>
      {puedeEditar && (
        <BotoneraFiltros
          filtros={filtrosPosiciones}
          selected={tipoPosiciones}
          onFiltroElegido={onTipoPosicionesElegido}
        />
      )}
      {!isCargando && posiciones && posiciones.length > 0 && (
        <PosicionesEtapaTorneo
          torneo={datosElegidos.torneo}
          posiciones={posiciones}
          onEquipoElegido={onEquipoElegido}
        />
      )}
      <MensajeCargando isCargando={isCargando} />
      <MensajeError errores={erroresGetLista} />
    </React.Fragment>
  );
};

export default PosicionesTorneo;
